/**
 * Scope de clínicas del usuario autenticado (JWT `allowedTenantIds`).
 * Mono = exactamente una clínica → layout “mi clínica hoy”.
 */

export function normalizeClinicIds(ids: readonly string[] | null | undefined): string[] {
  return (ids ?? []).map((id) => id.trim()).filter(Boolean);
}

/** Al menos una clínica en el alcance. Cero = empty de seguridad (sin métricas). */
export function hasClinicScope(ids: readonly string[] | null | undefined): boolean {
  return normalizeClinicIds(ids).length > 0;
}

/** Una sola clínica en scope (dueño mono o asistente limitado). */
export function isMonoClinicScope(ids: readonly string[] | null | undefined): boolean {
  return normalizeClinicIds(ids).length === 1;
}

/** Primera (y única) clínica en scope mono; null si no es mono. */
export function soleClinicId(ids: readonly string[] | null | undefined): string | null {
  const normalized = normalizeClinicIds(ids);
  return normalized.length === 1 ? normalized[0] : null;
}
